<template>
  <div class="app-root">
    <router-view />
    <store-setup-dialog />
    <transition name="global-loading-fade">
      <div v-if="$store.state.app.globalLoading" class="global-loading">
        <div class="global-loading__card"><span class="table-loading-spinner"><i></i><i></i><i></i></span><strong>正在切换页面</strong></div>
      </div>
    </transition>
  </div>
</template>

<script>
import StoreSetupDialog from '@/components/StoreSetupDialog/index.vue'

export default {
  name: 'App',
  components: { StoreSetupDialog },
  created() {
    this.$store.dispatch('app/loadMenuVisibility')
  }
}
</script>
